import { memo } from "react";

import Typography from "@mui/material/Typography";

import { getMarkdownAsReact } from "utility/markdown";

import Abstract from "./Abstract";

// -----------------------------------------------------------------------------

const OrganizationFindingFixRow = memo(function OrganizationFindingFixRow({
  description,
}: OrganizationFindingFixRowProps): JSX.Element {
  return (
    <Abstract label="Automated Fix">
      <Typography variant="body1" component="div">
        {description
          ? getMarkdownAsReact(description.trim())
          : "No automated fix currently available."}
      </Typography>
    </Abstract>
  );
});

export default OrganizationFindingFixRow;

// -----------------------------------------------------------------------------

interface OrganizationFindingFixRowProps {
  description: string;
}
